export default "__VITE_ASSET__B9up8dSA__"